export default "macro new(node)\n  {{node}}.new\nend\n\nnew BadType\n";